@if ((loadingService.isLoading$ | async)) {
    <app-main-loading/>
}

<router-outlet/>
